import { DynamicModule, Module, Global } from '@nestjs/common';
import { HttpModule, HttpService } from '@nestjs/axios';
import { AsyncConfiguration, Configuration } from './configuration';

import { ConnectApi } from './api/connect.service';
import { HealthApi } from './api/health.service';
import { ManualImportApi } from './api/manualImport.service';
import { SubscriptionApi } from './api/subscription.service';

@Global()
@Module({
  exports: [
    ConnectApi,
    HealthApi,
    ManualImportApi,
    SubscriptionApi,
  ],
})
export class ApiModule {
  static forRootAsync(options: AsyncConfiguration): DynamicModule {

    const optionsProvider = {
      provide: Configuration,
      useFactory: options.useFactory,
      inject: options.inject,
    };

    const httpModule = HttpModule.registerAsync({
      useFactory: (options: Configuration) => ({
        httpsAgent: options.httpsAgent,
        httpAgent: options.httpAgent,
      }),
      extraProviders: [
        ...(options.providers || []),
        optionsProvider,
      ],
      inject: [ Configuration ],
      imports: [ ...(options.imports || []) ]
    });

    return {
      module: ApiModule,
      providers: [
        ...(options.providers || []),
        optionsProvider,

        {
          provide: ConnectApi,
          useClass: ConnectApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: HealthApi,
          useClass: HealthApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: ManualImportApi,
          useClass: ManualImportApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: SubscriptionApi,
          useClass: SubscriptionApi,
          ...(options.scope && { scope: options.scope }),
        },

      ],
      imports: [
        ...(options.imports || []),
        httpModule,
      ]
    };
  }

  constructor( httpService: HttpService) { }
}
